/*
 * @Author: jankergg
 * @Date:   2019-08-05 10:56:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-12-26 21:59:47
 */
import Vue from 'vue';
import Vuex, { createNamespacedHelpers } from 'vuex';
import district from './module/district';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        
    },
    modules: {
        district
        
    },
    mutations: {
        
        
    },
    actions: {
        
    },
    
});
const { mapActions, mapState } = createNamespacedHelpers('Dict');
export const dictAction = mapActions;
export const dictState = mapState;
